<template>
  <div class="homeIbase flex flex-wrap w-full">
    <div class="flex w-full lg:w-6 image-column fadeInLeft">
      <img class="image-box" :src="imagem" />
    </div>
    <div class="flex w-full p-4 lg:w-6">
      <div class="homepage-title-group">
        <span class="sectionTitle" v-html="titulo"></span>
        <div class="subtitulo" v-html="subtitulo"></div>
        <div :class="'conteudo ' + (solucao == null || solucao === '' ? 'mb-6' : '')" v-html="conteudo"></div>
        <div class="btn">
          <div @click="fc_goRoute('solucao', { id: solucao })" v-if="(solucao != null && solucao != '')" class="btn-redireciona flex fadeindown animation-duration-1000 mt-5" v-html="fc_getText(null, 'btn_verMais')"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  props: {
    titulo: String,
    subtitulo: String,
    conteudo: String,
    solucao: Number,
    imagem: String,
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
  unmounted() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.homeIbase {
  padding-top: 60px;
}
.homeIbase .image-column {
  border-radius: 0px;
  display: flex;
  align-items: flex-end;
}
.homeIbase .image-column img {
  position: relative;
  width: 100%;
  height: 100%;
  max-height: 550px;
  object-fit: cover;
}
.homeIbase .homepage-title-group {
  max-width: 600px;
  padding-top: 25px;
  padding-bottom: 15px;
}
.homeIbase .homepage-title-group .titulo {
  margin-bottom: 10px;
}
@media screen and (max-width:1024px) {
  .homeIbase .homepage-title-group {
    max-width: 100%;
    padding: 0 15px;
  }
}
@media only screen and (min-width: 1141px) {
  .homeIbase {
    padding-top: 0px !important;
  }
}
@media screen and (min-width:1400px) {
  .homeIbase .image-column {
    display: flex;
    align-items: flex-end;
  }
  .homeIbase .image-column img {
    min-height: 350px;
  }
}
@media only screen and (min-width: 1900px) {
  .homeIbase {
    padding-top: 60px !important;
  }
}
</style>
